import React from "react";
import {
  FloatingFocusManager,
  FloatingPortal,
  useMergeRefs,
} from "@floating-ui/react";

import { useInputPopoverContext } from "@components/organisms/inputPopover/useInputPopoverContext";
import { Menu } from "@/components/atoms/menu";
import { MenuContent } from "@/components/atoms/menu/menu";

export const InputPopoverContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(function PopoverContent({ style, ...props }, propRef) {
  const { context: floatingContext, ...context } = useInputPopoverContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!context.open) return null;

  return (
    <FloatingPortal>
      <FloatingFocusManager
        context={floatingContext}
        modal={false}
        initialFocus={-1}
        disabled
      >
        <Menu
          ref={ref}
          style={{ ...context.floatingStyles, ...style }}
          {...context.getFloatingProps(props)}
        >
          <MenuContent>{props.children}</MenuContent>
        </Menu>
      </FloatingFocusManager>
    </FloatingPortal>
  );
});
